import { parse, theme } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  position: "relative"
});
export const content = parse({
  bg: "shade900",
  position: {
    _: "relative",
    medium: "absolute"
  },
  py: {
    _: "32",
    medium: "40",
    xlarge: "56"
  },
  px: {
    _: "16",
    medium: "40",
    xlarge: "56"
  }
}, "cclsg1y");
export const imageContainer = parse({
  position: "relative"
}, "ii0ljpl");
export const image = parse({
  position: "absolute",
  width: "100%",
  height: "100%"
}, "i12f53id");

require("./TextAndImageBoxed.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TextAndImageBoxed.styles.ts");